import { render } from "./invest.vue?vue&type=template&id=dc8d29e4&scoped=true"
import script from "./invest.vue?vue&type=script&lang=js"
export * from "./invest.vue?vue&type=script&lang=js"

import "./invest.vue?vue&type=style&index=0&id=dc8d29e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dc8d29e4"

export default script